import React, { useEffect, useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { Input } from 'antd';
import { groupBy, entries } from 'lodash';
import { Header, Stats, Calendar } from 'components/pages/leave-management';
import { theme } from 'styles/theme';
import LeaveTaken from 'assets/total-leaves-taken.svg';
import Approval from 'assets/waiting-for-approval.svg';
import GoBack from 'assets/go-back.svg';
import leavemgmtIllustration from 'assets/leavemgmt-illustration.svg';
import { Flex, Image, Text } from 'atoms';
import { setLeaveReason, requestLeave, leaveDashboard, leaveList } from 'store/leaveSlice';

const { TextArea } = Input;

const Container = styled(Flex)`
	position: relative;
	flex-direction: column;
`;

const Dashboard = styled(Flex)`
	position: absolute;
	top: 50px;
	width: 100%;
	height: 100px;
	background-repeat: no-repeat;
	background-size: cover;
	background-image: url(${leavemgmtIllustration});
`;

const StatsContainer = styled(Flex)`
	position: absolute;
	bottom: -10px;
	right: 5px;
	justify-content: space-between;
	width: 68%;
	padding: 5px 15px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.white};
	@media (max-width: 370px) {
		padding: 5px 6px;
	}
`;

const Arrow = styled(Flex)`
	position: absolute;
	top: 15px;
	left: 20px;
	width: 8%;
	padding: 8px 10px;
	border-radius: 25px;
	background-color: ${(props) => props.theme.colors.CelticBlue};
`;

const Caption = styled(Text)`
	position: absolute;
	bottom: 1px;
	left: 7px;
	padding: 8px;
	background-color: ${(props) => props.theme.colors.primary};
	font-size: 8px;
	color: ${(props) => props.theme.colors.white};
`;

const SelectedDate = styled(Text)`
	margin: 5px 10px;
	padding: 5px 10px;
	border-radius: 8px;
	background-color: ${(props) => props.theme.colors.white};
	div {
		align-items: center;
		width: 90%;
		height: auto;
		margin-left: 10px;
		padding: 10px;
		border-radius: 4px;
		border-left: 4px solid ${(props) => props.theme.colors.CelticBlue};
	}
`;

const Reason = styled(Flex)`
	flex-direction: column;
	justify-content: center;
	align-self: center;
	width: 100%;
	margin: 10px;
	padding: 10px;
	background-color: ${(props) => props.theme.colors.white};
	#reason {
		width: 98%;
		margin: 5px;
		padding: 5px;
		border-radius: 4px;
		border: 1px solid ${(props) => props.theme.colors.CelticBlue};
	}
`;

const Apply = styled(Flex)`
	justify-content: center;
	align-items: center;
	width: 98%;
	height: 40px;
	margin: 0 6px;
	margin-top: 10px;
	border-radius: 8px;
	background-color: ${(props) =>
		props.disable ? props.theme.colors.LightSteelBlue : props.theme.colors.CelticBlue};
	font-size: 12px;
	color: ${(props) => props.theme.colors.white};
	cursor: ${(props) => (props.disable ? 'not-allowed' : 'pointer')};
`;

export default function AddLeave() {
	const [text, setText] = useState([]);
	const [disable, setDisable] = useState(true);
	const history = useHistory();
	const dispatch = useDispatch();
	const { selectedDate = [], reason = '', dashboard = [] } = useSelector((state) => state.leave);
	const ApprovedLeave = dashboard.map((data) => data.approved_leave);
	const WaitingForApproval = dashboard.map((data) => data.pending_leave);

	useEffect(() => {
		dispatch(leaveDashboard());
		dispatch(leaveList());

		if (selectedDate.length) {
			const groupData = groupBy(selectedDate, (dt) => moment(dt).format('YYYY-MM'));
			const entriesData = entries(groupData).map((p) => ({
				key: moment(p[0]).format('YYYY - MMMM '),
				value: p[1].map((ar) => moment(ar).format(' DD ')),
			}));

			const displayData = entriesData.map((arr) => (
				<Fragment key={arr.key}>
					{arr.key} -{' '}
					{arr.value
						.sort()
						.map((v) => v)
						.join(',')}
					<br />
					<br />
				</Fragment>
			));

			console.log('displaydata', displayData);

			setText(displayData);
		}
		if (selectedDate.length === 0) setText([]);
	}, [dispatch, selectedDate]);

	useEffect(() => {
		if (reason && selectedDate.length !== 0) setDisable(false);
		else setDisable(true);
		dispatch(leaveList());
	}, [dispatch, reason, selectedDate]);

	return (
		<Container>
			<Header />
			<Dashboard>
				<Arrow onClick={() => history.push('/leave-management')}>
					<Image src={GoBack} alt="GoBack" heigth={20} width={20} />
				</Arrow>
				<Caption>Plan your leave perfectly</Caption>
				<StatsContainer>
					<Stats
						src={LeaveTaken}
						bg={theme.colors.Emerald}
						label="Total leaves taken"
						total={ApprovedLeave}
						alt="LeaveTaken"
						fontSize={8}
					/>
					<Stats
						src={Approval}
						bg={theme.colors.YellowOrg}
						label="Waiting for approval"
						total={WaitingForApproval}
						alt="Approval"
						fontSize={8}
					/>
				</StatsContainer>
			</Dashboard>
			<Calendar />
			<Text fontSize="10px" m="5px 20px" pl="10px">
				Selected Dates
			</Text>
			<SelectedDate>
				<Text fontSize="12px" lineHeight="15px" fontWeight="500">
					{text}
				</Text>
			</SelectedDate>
			<Reason>
				<TextArea
					id="reason"
					rows={3}
					placeholder="Reason"
					maxLength={100}
					size="small"
					value={reason}
					onChange={(e) => dispatch(setLeaveReason(e.target.value))}
				/>
				<Apply
					id="apply"
					disable={disable}
					onClick={() => dispatch(requestLeave(reason, selectedDate))}
				>
					Apply
				</Apply>
			</Reason>
		</Container>
	);
}
